module.exports = __webpack_public_path__ + "img/goods2.989d31c6.jpg";